export const VALIDATE_API = '/affiliates_signup/api/v1/validate';
